export default __webpack_public_path__ + "static/gift-cards-9f8f509ba9b30c3f4740520d21a482c3.png";